import { WholeNumber_Schema } from "@/utilities";
import { z } from "zod";
import { ParameterSlug_MarketplacePrice } from "./filterHelpers";

export const FilterOptionId_Schema = z.number().int();

// Fielter field option schema
export const FilterOption_Schema = z.object({
  id: FilterOptionId_Schema,
  value: z.string(),
  slug: z.string(),
  active: z.boolean(),
  ifSelectedCount: WholeNumber_Schema,
});

export enum FilterType {
  Text = "text",
  SingleSelect = "dropdown",
  Checkboxes = "checkboxes",
  Range = "slider",
  Radios = "radios",
}

export const FilterDefinition_Schema = z
  .object({
    id: z.number(), // Can be negative!
    slug: z.string(),
    name: z.string(),
    viewType: z.enum(FilterType),
    values: z.array(FilterOption_Schema),
    intMin: z.number(), // in cents
    intMax: z.number(), // in cents
    //unit: z.string().nullable(), // eg. Kč @todo

    // There are some extra properties, we do not use them
  })
  .transform(({ viewType, intMin, intMax, ...rest }) => ({
    ...rest,
    intMin: rest.slug === ParameterSlug_MarketplacePrice ? Math.floor(intMin / 100) : intMin,
    intMax: rest.slug === ParameterSlug_MarketplacePrice ? Math.ceil(intMax / 100) : intMax,
    unit: "Kč", // @todo not used now, hardcoded in filter component
    type: viewType,
  }));

// Sort option schema (no count)
export const SortOption_Schema = z.object({
  value: z.string(),
  label: z.string(),
});

// Sort definition schema
export const SortDefinition_Schema = z.object({
  field: z.string(),
  label: z.string(),
  options: z.array(SortOption_Schema),
  default: z.string(),
});

// Helpers:

/** Slug for the identification/fulltext filter field. */
export const IDENTIFICATION_FILTER_SLUG = "identification";

/** Slug for the theme (edice) filter field. */
export const THEME_FILTER_SLUG = "theme";
